import { gql } from "graphql-tag"

const typeProductRef = gql`
  type ProductRef {
    _id: ID!
    title: String

    images: [JSONObject]
    technicalManuals: [JSONObject]
    sdbManuals: [JSONObject]
    zertManuals: [JSONObject]

    attributes: [JSONObject]
    category: [Int]
    hidden: Boolean
    key: String
    mix: Boolean
    sale: Boolean
  }
`

export { typeProductRef }

export default typeProductRef
